// import Vue from 'vue';
// import VueAnalytics from 'vue-analytics';

// const GA = function () {
//     Vue.use(VueAnalytics, {
//         id: 'UA-34371062-1',
//         commands: {
//             ga(binding) {
//                 console.log(binding);
//                 this.$ga.event({
//                     eventCategory: binding.category,
//                     eventAction: binding.action,
//                     eventLabel: binding.label,
//                 });
//             },
//         },
//     });
// };

// export { GA };

import analyticsHelpers from '../helpers/analytics-helpers';

// Initialize the GA events directive.
const gaEvent = {
  bind(el, binding) {
    el.addEventListener('click', () => {
      analyticsHelpers.gaEvent(
        emptyString(binding.value.category),
        emptyString(binding.value.action), 
        emptyString(binding.value.label)
      );
      
    }, false);
  },
};

const emptyString = (value) => {
  if(value === "")
  {
    return '(not set)';
  }
  return value;
}

export {
  gaEvent,
};
